import { useNotifications } from '@/contexts/NotificationContext'

function ToastContainer() {
  const { toasts, dismissToast } = useNotifications()

  if (toasts.length === 0) return null

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className="toast">
          <div className="toast-header">
            <span className="toast-title">{toast.title}</span>
            <button
              className="toast-dismiss"
              onClick={() => dismissToast(toast.id)}
              aria-label="Dismiss"
            >
              &times;
            </button>
          </div>
          <p className="toast-body">{toast.body}</p>
          {toast.overdueItems?.length > 0 && (
            <div className="toast-overdue">
              <span className="toast-overdue-label">
                {toast.overdueItems.length} overdue:
              </span>
              <ul className="toast-overdue-list">
                {toast.overdueItems.map((item, i) => (
                  <li key={i}>
                    {item.title}
                    {item.parentTitle && (
                      <span className="toast-overdue-parent"> ({item.parentTitle})</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default ToastContainer
